<div class="spl-ui-coming-soon-feature">
  <div class="spl-ui-coming-soon-feature-grid">
    <h1 class="spl-ui-coming-soon-feature__logo">
      <img src="splitory-ui/assets/images/logo.svg" alt="" />

      <span> Splitory </span>
    </h1>

    <div class="spl-ui-coming-soon-feature__image">
      <img src="splitory-ui/assets/images/thinking.svg" alt="" />
    </div>

    <h2 class="spl-ui-coming-soon-feature__title">
      We're in a
      <br />
      <i> Brainstorming Phase </i>
    </h2>
  </div>

  <spl-ui-tagline></spl-ui-tagline>
</div>
